import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import useQueryFilter from 'hooks/useQueryFilter';
import {
  ListingQueryFilterParams,
  PORTFOLIO_FILTER,
  PortfolioFilter,
} from 'router/subrouters/Dash/subrouters/hooks/useBusinessesFilters';

import './PortfolioSellerOptions.styles.scss';

type PortfolioSellerOptionsProps = {
  className?: string;
};

const PORTFOLIO_FILTER_KEY = 'portfolioFilter';

const PortfolioSellerOptions: React.FC<PortfolioSellerOptionsProps> = (
  props,
) => {
  const { className } = props;

  const { isSuperAdmin, isEnterpriseHead } = useContext(CurrentUserContext);

  const {
    params: { portfolioFilter },
    onFiltersApply,
  } = useQueryFilter<ListingQueryFilterParams>();

  const { t } = useTranslation();

  const classes = classNames('portfolio-seller-options', className);

  const renderFilterButton = useCallback(
    (value: PortfolioFilter, text: string) => {
      return (
        <Button
          className={classNames({
            active:
              portfolioFilter === value ||
              (!portfolioFilter && value === 'all'),
          })}
          onClick={() => {
            onFiltersApply(PORTFOLIO_FILTER_KEY, value);
          }}
        >
          {text}
        </Button>
      );
    },
    [portfolioFilter, onFiltersApply],
  );

  if (!isSuperAdmin && !isEnterpriseHead) return null;

  return (
    <div className={classes}>
      {isSuperAdmin ? (
        <>
          {renderFilterButton(PORTFOLIO_FILTER.ALL, t('all'))}
          {renderFilterButton(PORTFOLIO_FILTER.MY_DEALS, t('resolve'))}
          {renderFilterButton(
            PORTFOLIO_FILTER.BROKER_MANAGED,
            t('brokerManaged'),
          )}
        </>
      ) : (
        <>
          {renderFilterButton(PORTFOLIO_FILTER.MY_DEALS, t('myDeals'))}
          {renderFilterButton(PORTFOLIO_FILTER.ALL, t('allDeals'))}
        </>
      )}
    </div>
  );
};

export default PortfolioSellerOptions;
